module.exports = __webpack_public_path__ + "static/media/administrative_areas.19a138dc.csv";